// Utils
import useResponsive from '@/hooks/useResponsive';

// Components
import Heading from '@/components/atoms/Heading/Heading';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';
import Markdown from '@/components/atoms/Markdown/Markdown';

// Other
import { type BlocMiseEnAvantCommandeType } from '@/services/blocksSchema';

// Style
import styles from './BlocMiseEnAvantCommande.module.css';

interface BlocMiseEnAvantCommandeProps {
  preTitle: BlocMiseEnAvantCommandeType['preTitle'];
  title: BlocMiseEnAvantCommandeType['title'];
  cards: BlocMiseEnAvantCommandeType['cards'];
}

function BlocMiseEnAvantCommande({
  preTitle,
  title,
  cards,
}: BlocMiseEnAvantCommandeProps) {
  const { isMobile } = useResponsive();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <PreTitle preTitle={preTitle} />
        <Heading
          title={title}
          Tag='h2'
          size='h2'
          color='dark'
        />
      </div>
      <div className={styles.cards}>
        {
          cards.sort((a, b) => a.order - b.order)
            .map((card, id) => (
              <div
                key={card.order}
                className={`${styles.card} ${id % 2 ? styles['card-white'] : styles['card-grey']}`}
              >
                <div className={styles['card-header']}>
                  <Heading
                    title={String(card.order)}
                    weight='700'
                    Tag='h2'
                    size='h2'
                    color='red'
                  />
                  {
                    isMobile ? (<div className={styles['card-line']} />) : null
                  }
                </div>
                {/* Text */}
                <div className={styles['card-body']}>
                  <Heading
                    title={card.title}
                    Tag='h4'
                    size='h4'
                    color='dark'
                  />
                  <Markdown 
                    text={card.description}
                    className={styles['card-description']}
                  />
                </div>
              </div>
            ))
        }    
      </div>
    </div>
  );
}

export default BlocMiseEnAvantCommande;
